import ErrorIcon from '@mui/icons-material/Error';
import {
  CircularProgress,
  InputAdornment,
  TextField as MuiTextField,
  TextFieldProps,
} from '@mui/material';
import React, { forwardRef, memo, useCallback } from 'react';

type Props = TextFieldProps & {
  loading?: boolean;
};

const Component: React.FC<Props> = forwardRef(({ loading, error, InputProps, ...props }, ref) => {
  const handleWheelChange: React.WheelEventHandler<HTMLDivElement> = useCallback(event => {
    // @ts-expect-error target has blur
    event.target.blur();
  }, []);

  return (
    <MuiTextField
      InputProps={{
        ...InputProps,
        endAdornment: loading ? (
          <InputAdornment position="end">
            <CircularProgress size={20} />
          </InputAdornment>
        ) : error ? (
          <InputAdornment position="end">
            <ErrorIcon sx={{ color: 'var(--error-color)' }} />
          </InputAdornment>
        ) : undefined,
      }}
      error={error}
      ref={ref}
      onWheel={props.type === 'number' ? handleWheelChange : undefined}
      {...props}
    />
  );
});

export const TextField = memo(Component);
